export default __webpack_public_path__ + "static/benchtop_lights-2b84936f443c3f2969edfaf35d041fa0.gif";